export default __webpack_public_path__ + "static/media/avatar.a25eb5db.svg";